module.exports = __webpack_public_path__ + "img/banano-bet-dark-wallpaper.8305d4df48321add498eaa2907267095.png";